import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import { BlogList, BlogPost } from "./pages/Blog";
import Denied from "./pages/Denied";

// Main app component that is exported
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        {/* <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} /> */}
        <Route path="*" element={<Denied />} />
      </Routes>
    </BrowserRouter>
  );
}
